import type { Instruction } from '~/types/instruction'

export const QRPAY_DEPOSIT_FORM_INSTRUCTION: Instruction = {
  title: 'Hướng dẫn nạp QRPay',
  steps: [
    {
      image: '/images/instruction/qrpay-deposit-step-1.webp',
      imageMobile: '/images/instruction/qrpay-deposit-step-1-mb.webp',
      title: 'Bước 1: Chọn số tiền',
      content: ['Chọn hoặc nhập số tiền muốn nạp.', 'Bấm tạo mã QR.'],
    },
    {
      image: '/images/instruction/qrpay-deposit-step-2.webp',
      imageMobile: '/images/instruction/qrpay-deposit-step-2-mb.webp',
      title: 'Bước 2: Quét mã QR',
      content: [
        'Quét QR code để nạp tiền qua ngân hàng hiển thị.',
        'Sau khi hoàn tất giao dịch ở app ngân hàng, ' +
          '<span class="instruction__highlight">Kiểm tra lịch sử giao dịch.</span>',
      ],
    },
  ],
}

export const PHONECARD_DEPOSIT_FORM_INSTRUCTION: Instruction = {
  title: 'Hướng dẫn nạp thẻ cào điện thoại',
  titleMobile: 'Hướng dẫn nạp thẻ cào',
  steps: [
    {
      image: '/images/instruction/phonecard-deposit-step-1-v2.webp',
      imageMobile: '/images/instruction/phonecard-deposit-step-1-mb-v2.webp',
      title: 'Bước 1: Chọn nhà mạng',
      content: [
        'Chọn ' +
          '<span class="instruction__highlight">Nhà mạng</span>' +
          ' cần nạp (Phí gạch thẻ phụ thuộc thị trường).',
        'Chọn ' +
          '<span class="instruction__highlight">Mệnh giá tiền</span>' +
          ' mà bạn muốn nạp.',
      ],
    },
    {
      image: '/images/instruction/phonecard-deposit-step-2.webp',
      imageMobile: '/images/instruction/phonecard-deposit-step-2-mb.png',
      title: 'Bước 2: Nhập thông tin',
      content: [
        'Nhập ' +
          '<span class="instruction__highlight">Mã thẻ (PIN)</span>' +
          ' trên thẻ cào.',
        'Nhập ' +
          '<span class="instruction__highlight">Số series</span>' +
          ' trên thẻ cào.',
        'Nhấn ' +
          '<span class="instruction__highlight">Nạp ngay</span>' +
          ' để tạo phiếu nạp.',
      ],
    },
  ],
}

export const EWALLET_DEPOSIT_FORM_INSTRUCTION: Instruction = {
  title: 'Hướng dẫn nạp ví điện tử',
  steps: [
    {
      image: '/images/instruction/ewallet-deposit-step-1.webp',
      imageMobile: '/images/instruction/ewallet-deposit-step-1-mb.png',
      title: 'Bước 1: Chọn ví điện tử',
      content: [
        'Chọn loại ' +
          '<span class="instruction__highlight">Ví điện tử</span>' +
          ' bạn muốn nạp.',
        'Chọn 1 ' +
          '<span class="instruction__highlight">Tài khoản nhận.</span>',
      ],
    },
    {
      image: '/images/instruction/ewallet-deposit-step-2.webp',
      imageMobile: '/images/instruction/ewallet-deposit-step-2-mb.png',
      title: 'Bước 2: Quét QR code',
      content: [
        'Sử dụng ' +
          '<span class="instruction__highlight">App của ví</span>' +
          ' để ' +
          '<span class="instruction__highlight">Quét mã QR</span>' +
          ' lấy thông tin giao dịch.',
        'Hoặc có thể nhập thủ công bằng cách ' +
          '<span class="instruction__highlight">Copy thông tin tài khoản.</span>',
        'Sau khi hoàn tất giao dịch ở ' +
          '<span class="instruction__highlight">Ví điện tử</span>' +
          ', vui lòng kiểm tra ' +
          '<span class="instruction__highlight">Lịch sử giao dịch.</span>',
      ],
    },
  ],
}

export const CRYPTO_DEPOSIT_FORM_INSTRUCTION: Instruction = {
  title: 'Hướng dẫn nạp crypto',
  steps: [
    {
      image: '/images/instruction/crypto-deposit-step-1.webp',
      imageMobile: '/images/instruction/crypto-deposit-step-1-mb.webp',
      title: 'Bước 1: Chọn ví crypto',
      content: [
        'Chọn loại ' +
          '<span class="instruction__highlight">Tiền ảo</span>' +
          ' bạn muốn nạp.',
        'Sử dụng ' +
          '<span class="instruction__highlight">App Crypto</span>' +
          ' để quét mã ' +
          '<span class="instruction__highlight">QR code</span>' +
          ' lấy thông tin giao dịch.',
        'Hoặc có thể nhập thủ công bằng cách ' +
          '<span class="instruction__highlight">Copy địa chỉ ví nạp.</span>',
      ],
    },
    {
      image: '/images/instruction/crypto-deposit-step-2.webp',
      imageMobile: '/images/instruction/crypto-deposit-step-2-mb.webp',
      title: 'Bước 2: Xác nhận thông tin',
      content: [
        'Kiểm tra lại các thông tin đầy đủ.',
        'Bấm vào ' +
          '<span class="instruction__highlight">Kiểm tra lịch sử giao dịch</span>' +
          ' để xem lịch sử giao dịch.',
      ],
    },
  ],
}

export const REGISTER_INSTRUCTION: Instruction = {
  title: 'Hướng dẫn đăng ký tài khoản',
  steps: [
    {
      image: '/images/instruction/register-step-1.webp',
      imageMobile: '/images/instruction/register-step-1-mb.webp',
      title: 'Bước 1:',
      content: [
        'Nhấn vào nút ' +
          '<span class="instruction__highlight">Đăng ký</span>' +
          ' ở góc phải phía trên màn hình để tiến hành đăng ký tài khoản mới.',
      ],
    },
    {
      image: '/images/instruction/register-step-2.webp',
      imageMobile: '/images/instruction/register-step-2-mb.webp',
      title: 'Bước 2: ',
      content: [
        'Hãy ' +
          '<span class="instruction__highlight">điền đầy đủ và chính xác thông tin</span>' +
          ' ở các ô theo gợi ý.',
        'Nhấn vào nút ' +
          '<span class="instruction__highlight">Đăng ký ngay</span>' +
          ' để hoàn thành đăng ký tài khoản.',
      ],
    },
  ],
}

export const BANK_WITHDRAW_INSTRUCTION: Instruction = {
  title: 'Hướng dẫn rút tiền ngân hàng',
  steps: [
    {
      image: '/images/instruction/bank-withdraw-step-1.webp',
      imageMobile: '/images/instruction/bank-withdraw-step-1-mb.webp',
      title: 'Bước 1: Thêm tài khoản ngân hàng',
      content: [
        'Nếu bạn chưa có tài khoản ngân hàng chính chủ để rút tiền, vui lòng nhấn vào ' +
          '<span class="instruction__highlight">Thêm tài khoản ngân hàng.</span>',
        'Điền đầy đủ thông tin yêu cầu, sau đó nhấn ' +
          '<span class="instruction__highlight">Lưu thông tin.</span>',
        'Kiểm tra lại thông tin ngân hàng của bạn rồi bấm ' +
          '<span class="instruction__highlight">Xác nhận.</span>',
      ],
    },
    {
      image: '/images/instruction/bank-withdraw-step-2.webp',
      imageMobile: '/images/instruction/bank-withdraw-step-2-mb.webp',
      title: 'Bước 2: Chọn ngân hàng',
      content: [
        'Chọn ' +
          '<span class="instruction__highlight">Ngân hàng chính chủ</span>' +
          ' của bạn.',
        'Nhập ' +
          '<span class="instruction__highlight">Số tiền muốn rút.</span>',
        'Nhấn ' +
          '<span class="instruction__highlight">Tạo phiếu nạp</span>' +
          ' để hoàn thành giao dịch.',
      ],
    },
  ],
}

export const PHONECARD_WITHDRAW_INSTRUCTION: Instruction = {
  title: 'Hướng dẫn rút tiền thẻ cào',
  titleMobile: 'Hướng dẫn rút thẻ cào',
  steps: [
    {
      image: '/images/instruction/phonecard-withdraw.webp',
      imageMobile: '/images/instruction/phonecard-withdraw-mobile.webp',
      title: 'Thực hiện các bước sau:',
      content: [
        'Chọn ' + '<span class="instruction__highlight">Nhà mạng.</span>',
        'Chọn ' +
          '<span class="instruction__highlight">Mệnh giá tiền</span>' +
          ' bạn muốn rút.',
        'Tuỳ chỉnh số thẻ muốn rút bằng nút ' +
          '<span class="instruction__highlight"> “-” “+”.</span>',
        'Nhấn ' +
          '<span class="instruction__highlight">Tạo phiếu rút</span>' +
          ' để hoàn thành giao dịch.',
      ],
    },
  ],
}

export const CRYPTO_WITHDRAW_INSTRUCTION: Instruction = {
  title: 'Hướng dẫn rút tiền crypto',
  steps: [
    {
      image: '/images/instruction/crypto-withdraw-step-1.webp',
      imageMobile: '/images/instruction/crypto-withdraw-step-1-mb.webp',
      title: 'Bước 1: Thêm địa chỉ ví',
      content: [
        'Chọn ' +
          '<span class="instruction__highlight">Thêm ví</span>' +
          ' nếu bạn chưa tạo địa chỉ ví của bạn.',
      ],
    },
    {
      image: '/images/instruction/crypto-withdraw-step-2.webp',
      imageMobile: '/images/instruction/crypto-withdraw-step-2-mb.webp',
      title: 'Bước 2: Nhập thông tin ví',
      content: [
        'Chọn ' +
          '<span class="instruction__highlight">Mạng lưới</span>' +
          ' và nhập chính xác ' +
          '<span class="instruction__highlight">Địa chỉ ví</span>' +
          ' của bạn, sau đó nhấn ' +
          '<span class="instruction__highlight">Xác nhận.</span>',
        'Kiểm tra lại thông tin và nhấn ' +
          '<span class="instruction__highlight">Xác nhận</span>' +
          ' để hoàn tất bước thêm địa chỉ ví.',
      ],
    },
    {
      image: '/images/instruction/crypto-withdraw-step-3.webp',
      imageMobile: '/images/instruction/crypto-withdraw-step-3-mb.webp',
      title: 'Bước 3: Tạo phiếu rút',
      content: [
        'Sau khi đã thêm địa chỉ ví, để rút tiền ảo hãy ' +
          '<span class="instruction__highlight">Nhập số điểm bạn muốn rút.</span>',
        'Nhấn ' +
          '<span class="instruction__highlight">Tạo phiếu rút</span>' +
          ' để hoàn tất giao dịch.',
      ],
    },
  ],
}
